import {getCommissionLedgerService, getCommissionLedgerSummaryService} from "@/services/commission-ledger.service";
import {useQuery} from "@tanstack/react-query";

const COMMISSION_LEDGER_KEY = ["commission-ledger"] as const;

interface CommissionLedgerFilters {
  operation_type?: string;
  currency?: string;
  limit?: number;
  offset?: number;
}

export const useCommissionLedger = (filters: CommissionLedgerFilters = {}) =>
  useQuery({
    queryKey: [...COMMISSION_LEDGER_KEY, filters],
    queryFn: async () => {
      const {data} = await getCommissionLedgerService(filters);
      if (data === undefined) throw new Error("No data");
      return data;
    },
  });

export const useCommissionLedgerSummary = (currency?: string) =>
  useQuery({
    queryKey: [...COMMISSION_LEDGER_KEY, "summary", currency],
    queryFn: async () => {
      const {data} = await getCommissionLedgerSummaryService(currency);
      if (data === undefined) throw new Error("No data");
      return data;
    },
  });
